import http from "./api-communicator";
import { responseFormatter } from "utils";
export { default as http } from "./api-communicator";

// let appData = {};

function logoutUser(token) {
  return responseFormatter(
    http.post(`logout`, null, {
      headers: {
        Authorization: token,
      },
    })
  );
}

function getUserDetails(token) {
  const options = {};
  if (token) {
    options.headers = {
      Authorization: token,
    };
  } else {
    options.setAuthHeader = true;
  }

  return responseFormatter(http.get("/user/me", options));
}

const getVersion = async () => {
  return responseFormatter(http.get("/version"));
};

const updateUserData = (userId, data) => {
  return responseFormatter(
    http.patch(`/user/${userId}`, data, { setAuthHeader: true })
  );
};

// const getAppData = () => {
//   return appData;
// };

// const setAppData = (key, data) => {
//   if (key) {
//     appData[key] = data;
//   } else {
//     appData = data;
//   }
// };

export const AppService = {
  getVersion,
  getUserDetails,
  logoutUser,
  //   getAppData,
  //   setAppData,
  updateUserData,
};
